<template>
  <div class="fixedBox">
    <div class="kf" style="border-bottom: 1px solid rgb(231, 237, 241); padding: 5px 0px; position: relative;">
      <img src="../../assets/images/talkIcon.png" style="width: 15px; height: 15px;">
      <div style="font-size: 16px; font-family: PingFangSC-Regular, &quot;PingFang SC&quot;; color: rgb(54, 68, 77);">
        咨询客服
      </div>
      <div class="kfQr" style="">
          <div style="font-size: 12px; font-family: PingFangSC-Regular, &quot;PingFang SC&quot;; color: rgb(50, 69, 78); line-height: 18px;">
              添加企业微信
              <br >为您一对一解答问题
          </div>
        <div >
        <img :src="baseURL + webData.qrImage" style="width: 99px; height: 99px;"></div>
      </div>
    </div>
    <div  class="dh" style="padding: 5px 0px; position: relative;">
      <div class="redOne"></div>
      <img src="../../assets/images/phoneIcon.png" style="width: 15px; height: 15px;">
      <div>联系我们</div>
      <div class="phone">{{webData.tel}}</div>
    </div>
  </div>
</template>
<script>
import {
    fetchWebsiteInfo,
  } from '@/api/api'
import {serverUrl} from '@/utils/server.js'
export default {
   data() {
      return {
        webData: null,
        baseURL: serverUrl.baseURL,
      }
   },
   created() {
      this.getWebData()
   },
   methods: {
     getWebData() {
       fetchWebsiteInfo().then(res => {
         this.webData = res.data
       })
     }
   }
}
</script>
<style scoped>
.fixedBox {
  position: fixed;
  right: 35px;
  top: 400px;
  width: 44px;
  height: 247px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(228, 233, 233, 0.46) 0px 2px 12px 3px;
  border-radius: 22px;
  writing-mode: lr-tb;
  text-align: center;
  padding: 0px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 999;
}
.kfQr{
  display: none;
  width: 158px;
  height: 158px;
  border: 1px solid rgb(0, 201, 173);
  position: absolute;
  left: -190px; top: -35px; padding: 8px 14px; box-sizing: border-box; box-shadow: rgba(228, 233, 233, 0.46) 0px 2px 12px 3px; border-radius: 8px;  background: rgb(255, 255, 255);
}
.kf:hover .kfQr{
  display: block;
}
.phone{
    font-size: 16px;
    font-family: DINMittelschriftStd;
    color: #69757d;
    line-height: 20px;
    border-radius: 6px;
    -webkit-box-shadow: 0 2px 12px 3px rgb(228 233 233 / 46%);
    box-shadow: 0 2px 12px 3px rgb(228 233 233 / 46%);
    display: none;
}
.dh:hover .phone{
    position: absolute;
    left: -190px;
    top: 30px;
    display: block!important;
    background: #fff;
    padding: 5px 10px;
    width: 144px;
    height: 30px;
    text-align: center;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/node/Contact.vue